// React
import { ReactElement } from 'react';
// Next
import { useTranslation } from 'next-i18next';
// Design System
import { Button } from '@utmb/design-system/button/Button';
// Types
import { ColorTypesEnum } from '@utmb/types/colors';
// Utils
import { getColorStyle } from '@utmb/utils/colors';
// Styles
import styles from './actions-buttons.module.scss';

interface ActionsButtonsProps {
    onCancel: () => void;
    confirmTitle?: string;
    clsConfirm?: string;
    disabled?: boolean;
}

export const ActionsButtons = (props: ActionsButtonsProps): ReactElement => {
    const { onCancel, confirmTitle, clsConfirm, disabled } = props;

    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <Button.Default
                color={getColorStyle(ColorTypesEnum.WHITE)}
                bgcolor={getColorStyle(ColorTypesEnum.DEFAULT)}
                type="button"
                label={t('myutmb:myUtmb.formButtons.cancel')}
                onPress={onCancel}
            />
            <Button.Default
                color={getColorStyle(ColorTypesEnum.WS_SECONDARY)}
                bgcolor={getColorStyle(ColorTypesEnum.WS_PRIMARY)}
                type="submit"
                disabled={disabled}
                className={clsConfirm}
                label={confirmTitle || t('myutmb:myUtmb.formButtons.submit')}
            />
        </div>
    );
};
